import { AttachmentList } from 'app/src/shared/components/AttachmentList'
import { useWebAppContext } from 'app/src/shared/hooks'
import { useTranslation } from 'react-i18next'

export function CatalogProductListSection() {
  const context = useWebAppContext()
  const { t } = useTranslation('catalog', { keyPrefix: 'Catalog.CatalogProductList' })

  return (
    context.userInfo.welfareCampaign.documents &&
    context.userInfo.welfareCampaign.documents.length > 0 &&
    context.userInfo.welfareCampaign.documents.filter((el) => el.type === 'catalog').length > 0 && (
      <AttachmentList
        attachments={context.userInfo.welfareCampaign.documents
          .filter((el) => el.type === 'catalog')
          .map((d) => ({
            id: d.documentId!,
            name: d.name!,
            resourceLink: d.url,
            type: d.type!,
          }))}
        title={t('Title')}
      />
    )
  )
}
